import "./detail.less";
import { useContext, useEffect, useState } from "react";
import { Modal, Skeleton, Tooltip } from "antd";
import { getGlobalLoadDisplacementDetail } from "@/api/lib/lib-load-displacement";
import { GlobalLoadDisplacement } from "@/global/interface/lib-device/global-load-dispalcement";
import EChartsReact from "echarts-for-react";

interface IProps {
    relationUuid: string
    needRender: boolean
}

export default function LibConstitutiveRelationDetail(props: IProps) {
    const [relation, setRelation] = useState<GlobalLoadDisplacement>(null); // 关系
    const [loading, setLoading] = useState<boolean>(false); // loading
    const [lineData, setLineData] = useState<[][]>([]); // 数据


    // 初始化
    useEffect(() => {
        if (!props?.relationUuid) return;
        generateData();
    }, [props?.relationUuid, props?.needRender])

    // 获取数据
    const generateData = () => {
        setLoading(true)
        getGlobalLoadDisplacementDetail(props?.relationUuid).then(res => {
            let data: GlobalLoadDisplacement = res.data || null;
            let loadLength = data?.load?.length || 0;
            let displacementLength = data?.displacement?.length || 0;
            let min = Math.min(loadLength, displacementLength);
            let lineData = [];
            for (let i = 0; i < min; i++) {
                let arr = []
                arr.push(Number(data?.load[i]?.toFixed(3)), Number(data?.displacement[i]?.toFixed(3)))
                lineData.push(arr);
            }
            setLineData(lineData);
            setRelation(data);
        }).finally(() => {
            setLoading(false);
        })
    }


    const options = {
        backgroundColor: 'rgba(1, 1, 1, 0)',
        title: {
            text: "",
            left: "left",
            textStyle: {
                fontSize: "18px",
                color: "#0C51C8",
                fontWeight: 400,
            },
            backgroundColor: "#fff",
            padding: 0,
            borderRadius: [8, 0, 0, 0]
        },
        tooltip: {
            trigger: "axis",
            formatter: function (params) {
                if (params[0]?.data?.length <= 0) return '';
                const date: number = params[0]?.data[0]; // x 轴的值
                let xValue = date.toString()
                let res = ''
                const value = params[0].data[1]; // y 轴的值
                let yValue = value.toString()
                res = `${relation?.axisXName || 'X'}: ${xValue}${relation?.axisXUnit || ""}
                        <br/>
                       ${relation?.axisYName || 'Y'}: ${yValue}${relation?.axisYUnit || ""}`
                return res;
            }
        },
        xAxis: {
            type: 'category',
            name: relation?.axisXUnit || "x",
            nameLocation: "end",
            nameGap: 30,
            nameTextStyle: {
                fontSize: "12px",
                fontWeight: 400,
                verticalAlign: 'top',
                color: "#292929" // X轴单位颜色
            },
            axisLine: {
                lineStyle: {
                    color: '#363636', // X轴颜色
                    width: 3,
                },
                symbol: ['none', 'arrow'], // 在X轴的正方向上添加箭头
                symbolSize: [12, 15], // 箭头大小
                symbolOffset: [0, 10]
            },
            axisLabel: {
                color: '#292929', // X轴标签颜色
                formatter: function (value) {
                    return value
                },
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#DFDFDF', // X轴网格线颜色
                    width: 1,
                    type: 'solid'
                },
                interval: 20
            },
            axisTick: {
                alignWithLabel: true, // 使刻度线与标签对齐
            },
        },
        yAxis: {
            type: 'value',
            name: relation?.axisYUnit || "y",
            nameLocation: "end",
            nameGap: 24,
            nameTextStyle: {
                fontSize: "12px",
                fontWeight: 400,
                verticalAlign: 'top',
                color: "#292929" // Y轴单位颜色
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#363636', // Y轴颜色
                    width: 3
                },
                symbol: ['none', 'arrow'], // 在Y轴的正方向上添加箭头
                symbolSize: [12, 15], // 箭头大小
                symbolOffset: [0, 10]
            },
            axisLabel: {
                color: '#292929', // Y轴标签颜色
                formatter: function (value) {
                    return value
                },
            },
            splitLine: {
                lineStyle: {
                    color: '#DFDFDF', // Y轴网格线颜色
                    width: 1,
                    type: "solid"
                },
                interval: 1
            },
            axisTick: {
                alignWithLabel: true, // 使刻度线与标签对齐
            },
        },
        grid: {
            left: '3%',   // 调整左边距
            right: '8%',  // 调整右边距
            top: '5%',   // 调整上边距
            bottom: '0%', // 调整下边距
            containLabel: true  // 防止标签溢出容器
        },
        series: [
            {
                data: lineData,
                type: 'line',
                smooth: false,
                lineStyle: {
                    color: '#ff0000', // 折线颜色
                    width: 2, // 折线宽度
                },
                showSymbol: false, // 隐藏数据点
                emphasis: {
                    focus: 'series',
                    itemStyle: {
                        color: '#ff0000', // 鼠标悬停时数据点的颜色
                        borderColor: '#ff0000', // 鼠标悬停时数据点的边框颜色
                        borderWidth: 3, // 边框宽度
                    },
                },
            }
        ],
    }

    return (
        <div className="lib-parameter-detail-container">
            <Skeleton loading={loading}>
                <div className="title">
                    {relation?.name || ''}
                </div>
                <div className="main">
                    {lineData?.length > 0 && <EChartsReact
                        style={{
                            background: `#F6F6F6`,
                            width: "100%",
                            height: "100%",
                            borderRadius: "8px"
                        }}
                        option={options}
                    />}
                </div>
            </Skeleton>
        </div>
    )
}